import { HelpCircle } from 'lucide-react'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'
import { Link } from '@inertiajs/react'

interface HelpTooltipProps {
  content: string
  learnMore?: string
}

export function HelpTooltip({ content, learnMore }: HelpTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            aria-label="Help"
            className="ml-1 inline-flex text-muted-foreground hover:text-foreground"
          >
            <HelpCircle className="h-4 w-4" />
          </button>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">
          <p className="text-sm">{content}</p>
          {learnMore && (
            <Link
              href={learnMore}
              className="mt-1 inline-block text-xs text-primary hover:underline"
            >
              Learn more
            </Link>
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
